import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useContactUs } from "hooks/useContactUs";

interface ContactFormProps {
  /** Called after the message is sent successfully (e.g. to close a modal). */
  onSuccess?: () => void;
  title?: string;
}

const ContactForm: React.FC<ContactFormProps> = ({
  onSuccess,
  title = "Leave your message",
}) => {
  const { mutate: submitContactForm, isPending } = useContactUs();
  const [searchParams] = useSearchParams();
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    subject: searchParams.get("subject") ?? "",
    message: searchParams.get("message") ?? "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    submitContactForm(
      {
        full_name: form.fullName,
        email: form.email,
        subject: form.subject,
        message: form.message,
      },
      {
        onSuccess: () => {
          setForm({ fullName: "", email: "", subject: "", message: "" });
          onSuccess?.();
        },
      }
    );
  };

  return (
    <>
      <h3 className="text-2xl lg:text-4xl font-bold text-[#012169] mb-6">
        {title}
      </h3>
      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-base font-medium text-[#344054] mb-1.5">
            Full Name
          </label>
          <input
            type="text"
            name="fullName"
            value={form.fullName}
            onChange={handleChange}
            placeholder="Enter your full name"
            className="w-full px-4 py-3 border border-[#D0D5DD] rounded-lg text-sm placeholder:text-[#98A2B3] focus:outline-none focus:border-[#012169] transition-colors"
            required
          />
        </div>
        <div>
          <label className="block text-base font-medium text-[#344054] mb-1.5">
            Email address
          </label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Enter your email address"
            className="w-full px-4 py-3 border border-[#D0D5DD] rounded-lg text-sm placeholder:text-[#98A2B3] focus:outline-none focus:border-[#012169] transition-colors"
            required
          />
        </div>
        <div>
          <label className="block text-base font-medium text-[#344054] mb-1.5">
            Subject
          </label>
          <input
            type="text"
            name="subject"
            value={form.subject}
            onChange={handleChange}
            placeholder="Enter subject"
            className="w-full px-4 py-3 border border-[#D0D5DD] rounded-lg text-sm placeholder:text-[#98A2B3] focus:outline-none focus:border-[#012169] transition-colors"
            required
          />
        </div>
        <div>
          <label className="block text-base font-medium text-[#344054] mb-1.5">
            Message
          </label>
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="Enter message..."
            rows={8}
            className="w-full px-4 py-3 border border-[#D0D5DD] rounded-lg text-sm placeholder:text-[#98A2B3] focus:outline-none focus:border-[#012169] transition-colors resize-none"
            required
          />
        </div>
        <button
          type="submit"
          disabled={isPending}
          className="w-full py-3.5 bg-[#012169] text-white font-semibold rounded-lg hover:bg-[#01154d] transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {isPending ? "Sending..." : "Send Message"}
        </button>
      </form>
    </>
  );
};

export { ContactForm };
